<template>
    <div class="clients">
        <div class="clients__header">
            <div class="clients__header-desc">
                <h1>{{ $t('clients.clients.oAuthAPIApplications') }}</h1>
                <p v-html="$t('clients.clients.oAuthAPIApplicationsDescription', {a: '<a href=\'/apidoc\' target=\'_blank\'>', b: '</a>', interpolation: { escapeValue: false } })" />
            </div>

            <div
                class="clients__header-btn"
                v-if="clients.length"
            >
                <Button
                    type="primary"
                    @click.native="addPopupShow"
                    class="da-ui--color__btn_fill btn_add-client"
                >
                    <svg width="13px" height="13px" viewBox="0 0 13 13">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M7.58333333,5.41666667 L13,5.41666667 L13,7.58333333 L7.58333333,7.58333333 L7.58333333,13 L5.41666667,13 L5.41666667,7.58333333 L-3.55271368e-15,7.58333333 L-3.55271368e-15,5.41666667 L5.41666667,5.41666667 L5.41666667,0 L7.58333333,0 L7.58333333,5.41666667 Z" />
                        </g>
                    </svg>
                    <span>{{ $t('clients.clients.createNewApp') }}</span>
                </Button>
            </div>
        </div>

        <div
            v-if="!clientsIsLoading && !clients.length"
            style="margin-top: 40px"
        >
            <AddForm
                :value="client"
                @input="(newClient) => {client = newClient}"
            />
        </div>

        <div
            v-if="!clientsIsLoading && clients.length"
        >
            <div class="client-item client-item_header">
                <div class="client-item__row client-item__row_name">{{ $t('clients.clients.name') }}</div>
                <div class="client-item__row client-item__row_id">{{ $t('clients.clients.appID') }}</div>
                <div class="client-item__row client-item__row_key">{{ $t('clients.clients.aPIKey') }}</div>
                <div class="client-item__row client-item__row_btns" />
            </div>
            <div
                v-for="client in orderBy(clients, 'id')"
                :key="client.id"
                class="client-item"
            >
                <div class="client-item__row client-item__row_name" :data-title="$t('clients.clients.name')">{{ client.name }}</div>
                <div class="client-item__row client-item__row_id" :data-title="$t('clients.clients.appID')">{{ client.id }}</div>
                <Secret
                    class="client-item__row client-item__row_key"
                    :data="client.secret"
                    :data-title="$t('clients.clients.aPIKey')"
                />

                <div class="client-item__row client-item__row_btns">
                    <div
                        class="client-item__btn"
                        @click="editClient(client.id, client.name, client.redirect)"
                    >
                        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
                            <defs>
                                <linearGradient x1="79.7940341%" y1="13.6777936%" x2="8.51004464%" y2="100%" id="linearGradient">
                                    <stop stop-color="#F59C07" offset="0%" />
                                    <stop stop-color="#F57507" offset="100%" />
                                </linearGradient>
                            </defs>
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g class="color-icon" transform="translate(-1078.000000, -451.000000)" fill-rule="nonzero">
                                    <g transform="translate(30.000000, 220.000000)">
                                        <g transform="translate(20.000000, 229.000000)">
                                            <g transform="translate(1028.000000, 2.000000)">
                                                <path d="M15.211345,0 C14.5141809,0 13.8554435,0.347106401 13.3064956,0.892561331 L1.90484935,12.2754828 L0,18 L5.7035684,16.0936645 L5.82433763,15.9779624 L17.1161943,4.71625372 C17.659653,4.1652895 18,3.50413244 18,2.80440753 C18,2.10468261 17.659653,1.44352555 17.1161943,0.892561331 C16.5672465,0.347106401 15.9085091,0 15.211345,0 Z M12.3952429,3.79063383 L14.2122606,5.61983504 L4.94602109,14.8650139 L2.2232398,15.7741046 L3.13449251,13.0358127 L12.3952429,3.79063383 Z" />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <span>{{ $t('clients.clients.edit') }}</span>
                    </div>
                    <div
                        class="client-item__btn"
                        @click="toggleDelPopup(client.id, client.name)"
                    >
                        <svg width="16px" height="20px" viewBox="0 0 16 20">
                            <defs>
                                <linearGradient x1="68.5985166%" y1="13.6777936%" x2="24.1004652%" y2="100%" id="linearGradient">
                                    <stop stop-color="#F59C07" offset="0%" />
                                    <stop stop-color="#F57507" offset="100%" />
                                </linearGradient>
                            </defs>
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g class="color-icon" transform="translate(-1234.000000, -449.000000)" fill-rule="nonzero">
                                    <g transform="translate(30.000000, 220.000000)">
                                        <g transform="translate(20.000000, 229.000000)">
                                            <g transform="translate(1184.000000, 0.000000)">
                                                <path d="M9.08407313,5.55555556 L8.88888889,16.6666667 L10.9159269,16.6666667 L11.1111111,5.55555556 L9.08407313,5.55555556 Z M6.47148243,5.55555556 L4.44444444,5.55555556 L4.63962868,16.6666667 L6.66666667,16.6666667 L6.47148243,5.55555556 Z M12.4117847,17.5255086 L12.4111048,17.5579504 C12.4111048,17.6216249 12.3533061,17.6734109 12.2825878,17.6734109 L3.52235535,17.6734109 C3.45073038,17.6734109 3.39247843,17.6216249 3.39247843,17.5579504 L2.94708898,5.24398293 L0.679569373,5.24398293 L1.12586547,17.5766901 C1.13742519,18.7429816 2.2079465,19.6884274 3.52235535,19.6884274 L12.2825878,19.6884274 C13.5963167,19.6884274 14.6666113,18.7427801 14.6777177,17.5764886 L15.1240138,5.24398293 L12.8564942,5.24398293 L12.4117847,17.5255086 Z M11.3827737,2.18321603 L10.9789431,2.13162821e-14 L4.37631245,2.13162821e-14 L3.97248183,2.18321603 L0,2.18321603 L0,4.44444444 L15.5555556,4.44444444 L15.5555556,2.18321603 L11.3827737,2.18321603 Z" />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <span>{{ $t('clients.clients.delete') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="popup__box"
            v-if="showDelPopup"
        >
            <div class="popup__title">
                <span>
                    {{ $t('clients.clients.removeConfirmationHeader', {name: client.clientName}) }}
                </span>
            </div>

            <div class="popup__text">
                <span>
                    {{ $t('clients.clients.removeConfirmationBody') }}
                </span>
            </div>

            <div>
                <Button
                    type="primary"
                    @click.native="deleteClient(client.clientId)"
                    class="da-ui--color__btn_fill"
                >
                    <span>{{ $t('clients.yes') }}</span>
                </Button>

                <Button
                    @click.native="toggleDelPopup"
                    style="margin-left: 15px;"
                >
                    <span>{{ $t('clients.cancel') }}</span>
                </Button>
            </div>
        </div>

        <div
            class="popup__box"
            v-if="popupShow"
        >
            <div class="popup__title">
                <span
                    v-if="!client.clientId"
                >
                    {{ $t('clients.clients.newApplication') }}
                </span>
                <span
                    v-if="client.clientId"
                >
                    {{ $t('clients.clients.editApplication') }}
                </span>

                <span
                    class="popup__close"
                    @click="togglePopup"
                >
                    <svg width="20px" height="20px" viewBox="0 0 20 20">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g transform="translate(-948.000000, -343.000000)" fill-rule="nonzero" stroke="#fff" stroke-width="2">
                                <g transform="translate(383.000000, 328.000000)">
                                    <g transform="translate(565.000000, 15.000000)">
                                        <polygon points="10 10 1.51471863 18.4852814 10 10 1.51471863 1.51471863 10 10 18.4852814 1.51471863 10 10 18.4852814 18.4852814" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </span>
            </div>

            <AddForm
                :value="client"
                @input="(newClient) => {client = newClient}"
                :toggle-popup="togglePopup"
            />
        </div>

        <div
            class="cape"
            v-if="clientsIsLoading || globalLoader || popupShow || showDelPopup"
        />

        <div
            v-if="clientsIsLoading || globalLoader"
        >
            <Loader />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { ACTIONS as ACTIONS_CLIENTS } from '../../store/clients'

import Button from '../../components/ui/button'
import Loader from '../../components/ui/loader'
import AddForm from './addForm'
import Secret from './secret'

export default {
    name: 'Clients',

    components: {
        Button,
        AddForm,
        Secret,
        Loader,
    },

    data: () => {
        return {
            popupShow: false,
            showDelPopup: false,
            client: {
                clientName: '',
                clientUrl: '',
                clientId: null,
            },
        }
    },

    computed: {
        ...mapGetters([
            'clientsIsLoading',
            'clients',
            'globalLoader',
            'successClient',
        ])
    },

    watch: {
        successClient(val) {
            if (val === 'done') this.hidePopup()
        },
    },

    mounted() {
        this.$store.dispatch(ACTIONS_CLIENTS.FETCH_CLIENTS)
    },

    methods: {
        orderBy(arr, key) {
            return [ ...arr ].sort((a, b) => b[key] - a[key])
        },

        addPopupShow() {
            this.client.clientName = ''
            this.client.clientUrl = ''
            this.client.clientId = null
            this.popupShow = true
        },

        hidePopup() {
            this.client.clientName = ''
            this.client.clientUrl = ''
            this.client.clientId = null
            this.popupShow = false
        },

        togglePopup() {
            if (this.popupShow) {
                this.client.clientName = ''
                this.client.clientUrl = ''
                this.client.clientId = null
            }

            this.popupShow = !this.popupShow
        },

        editClient(id, name, redirect) {
            this.popupShow = true
            this.client.clientName = name
            this.client.clientUrl = redirect
            this.client.clientId = id
        },

        deleteClient(id) {
            this.toggleDelPopup()
            this.$store.dispatch(ACTIONS_CLIENTS.DEL_CLIENTS, id)
        },

        toggleDelPopup(id, name) {
            if (this.showDelPopup) {
                this.showDelPopup = false
                this.client.clientId = null
                this.client.clientName = ''
            } else {
                this.showDelPopup = true
                this.client.clientId = id
                this.client.clientName = name
            }
        },
    },
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.clients {
    margin-bottom: 40px;
    margin-top: 20px;
    min-height: 500px;

    &__header {
        margin-bottom: 20px;

        &-desc {
            padding-right: 20px;

            h1 {
                font-size: 24px;
                font-weight: 300;
                color: rgba(241, 241, 241, 1);
                margin: 0 0 15px 0;
            }

            p {
                font-size: 14px;
                color: rgba(131, 131, 131, 1);
                line-height: 1.5;
                margin-bottom: 15px;

                @include bp('md') {
                    margin-bottom: 0;
                }
            }
        }

        @include bp('md') {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}

.popup {
    &__box {
        position: fixed;
        min-width: 280px;
        background-color: #1f1f1f;
        border-radius: 8px;
        // max-width: 600px;
        padding: 30px;
        z-index: 2;
        box-shadow: 0 4px 16px rgba(black, .2);
        top: 100px;
        right: 15px;
        bottom: 15px;
        left: 15px;

        @include bp('sm') {
            top: 40%;
            right: auto;
            bottom: auto;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    &__title {
        font-size: 22px;
        font-weight: 300;
        color: rgba(241, 241, 241, 1);
        line-height: 1;
        margin-bottom: 30px;
    }

    &__text {
        line-height: 1;
        margin-bottom: 30px;
    }

    &__close {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
        opacity: .7;

        svg {
            display: block;
        }

        &:hover {
            opacity: 1;
        }
    }
}

.client-item {
    padding: 20px;
    color: rgba(241, 241, 241, 1);
    line-height: 20px;
    cursor: default;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    &_header {
        padding: 10px 20px;
        color: rgba(131, 131, 131, 1);
        display: none;

        @include bp('md') {
            display: flex;
        }
    }

    &:nth-child(2n) {
        background: #262626;
    }

    &__btn {
        display: inline-block;
        line-height: 20px;
        border: 0;
        margin-left: 30px;
        white-space: nowrap;
        cursor: pointer;
        margin-top: 15px;

        @include bp('lg') {
            margin-top: 0;
        }

        svg {
            display: inline-block;
            vertical-align: middle;
            line-height: inherit;
            margin-right: 10px;
        }

        span {
            vertical-align: middle;
            line-height: inherit;
        }

        .color-icon {
            fill: #838383;
        }

        &:hover {
            color: rgba(245, 125, 7, 1);

            .color-icon {
                fill: url(#linearGradient);
            }
        }
    }

    &__row {
        &_name,
        &_id,
        &_key {
            &:before {
                display: block;
                content: attr(data-title);
                font-size: .8em;
                color: #838383;
            }

            @include bp('md') {
                &:before {
                    display: none;
                }
            }
        }

        &_name,
        &_id,
        &_key {
            margin-bottom: 15px;
        }

        &_name {
            width: 75%;
        }

        &_id {
            width: 25%;
        }

        &_key {
            width: 100%;
        }

        &_btns {
            text-align: right;
            width: 100%;
        }

        @include bp('xs') {
            &_name {
                width: 80%;
            }

            &_id {
                width: 20%;
            }

            &_key {
                width: 100%;
            }

            &_btns {
                width: 100%;
            }
        }

        @include bp('md') {
            &_name {
                width: 25%;
            }

            &_id {
                width: 15%;
            }

            &_key {
                width: 60%;
            }

            &_btns {
                width: 100%;
            }
        }

        @include bp('lg') {
            &_name {
                width: 20%;
                margin-bottom: 0;
            }

            &_id {
                width: 10%;
                margin-bottom: 0;
            }

            &_key {
                width: 40%;
                margin-bottom: 0;
            }

            &_btns {
                width: 30%;
            }
        }
    }
}

.btn_add-client {
    svg {
        path {
            fill: #fff;
        }
    }

    &:hover {
        svg {
            path {
                fill: #f57507;
            }
        }
    }
}

.popup__confirm {
    position: fixed;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    border-radius: 8px;
    background-color: #1f1f1f;
    box-shadow: 0 4px 16px rgba(black, .2);
}

.cape {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1c1c1c;
    opacity: .8;
}
</style>
